import { render, staticRenderFns } from "./ClientDigitalCardForm.vue?vue&type=template&id=77803248&"
import script from "./ClientDigitalCardForm.vue?vue&type=script&lang=js&"
export * from "./ClientDigitalCardForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientDigitalCardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports